import React from 'react';

const DiscordCard = () => {
  return (
    <div className="bg-gradient-to-br from-indigo-600 to-purple-600 rounded-xl p-6 border border-indigo-400/20 relative overflow-hidden">
      {/* Decorative shapes */}
      <div className="absolute top-0 right-0 w-24 h-24 bg-white/10 rounded-full blur-2xl"></div>
      <div className="absolute bottom-0 left-0 w-32 h-32 bg-purple-400/20 rounded-full blur-2xl"></div>
      
      <div className="relative z-10">
        <div className="flex items-center justify-center mb-4">
          <div className="w-16 h-16 bg-white rounded-2xl flex items-center justify-center">
            <i className="fab fa-discord text-indigo-600 text-3xl"></i>
          </div>
        </div>
        
        <h3 className="text-xl font-bold text-white text-center mb-2">
          Rejoins notre Discord !
        </h3>
        
        <p className="text-sm text-indigo-100 text-center mb-5">
          Discute avec la communauté, obtiens de l'aide et participe aux événements exclusifs.
        </p>
        
        <div className="space-y-2 mb-5">
          <div className="flex items-center gap-2 text-white text-sm">
            <i className="fas fa-users w-5 text-indigo-200"></i>
            <span>Communauté active et bienveillante</span>
          </div>
          <div className="flex items-center gap-2 text-white text-sm">
            <i className="fas fa-gift w-5 text-indigo-200"></i>
            <span>Événements et récompenses</span>
          </div>
          <div className="flex items-center gap-2 text-white text-sm">
            <i className="fas fa-life-ring w-5 text-indigo-200"></i>
            <span>Support technique réactif</span>
          </div>
        </div>
        
        <a
          href="https://discord.gg/sunserv"
          target="_blank"
          rel="noopener noreferrer"
          className="block w-full bg-white hover:bg-gray-100 text-indigo-600 font-bold py-3 rounded-lg transition-all hover:scale-105 text-center"
        >
          <i className="fab fa-discord mr-2"></i>
          Rejoindre maintenant
        </a>
      </div>
    </div>
  );
};

export default DiscordCard;
